import { useState } from 'react';
import { motion } from 'framer-motion';
import styles from './Contact.module.css';

const SERVICES = [
  'Bridal Makeup',
  'Party & Event Makeup',
  'Skincare & Facials',
  'Hair Styling',
  'Pre-Bridal Package',
  'Destination Bridal',
  'Other',
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.7, delay },
});

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    service: '',
    date: '',
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, service, date } = form;
    const msg = `Hi, I am ${name}, my number is ${phone}. I am interested in ${service} on ${date}. Please confirm availability.`;
    const url = `https://wa.me/918890469900?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const INFO_ITEMS = [
    { icon: '📍', label: 'Location', value: 'Bharatpur, Rajasthan, India' },
    { icon: '📞', label: 'Phone', value: '+91 88904 69900' },
  ];

  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.inner}>
        {/* Heading */}
        <motion.div className={styles.heading} {...fadeUp()}>
          <div className={styles.headingTag}>Get in Touch</div>
          <h2 className={styles.headingTitle}>Book Your Appointment</h2>
        </motion.div>

        <div className={styles.grid}>
          {/* Left — Info */}
          <motion.div className={styles.info} {...fadeUp(0.1)}>
            <div>
              <h3 className={styles.infoTitle}>Visit Us or Book via WhatsApp</h3>
            </div>

            <div className={styles.infoItems}>
              {INFO_ITEMS.map((item) => (
                <div key={item.label} className={styles.infoItem}>
                  <span className={styles.infoIcon}>{item.icon}</span>
                  <div>
                    <strong>{item.label}</strong>
                    {item.value}
                  </div>
                </div>
              ))}

              <div className={styles.infoItem}>
                <span className={styles.infoIcon}>📸</span>
                <div>
                  <strong>Instagram</strong>
                  <a
                    href="https://www.instagram.com/shobha.salon/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'var(--accent-gold)' }}
                  >
                    @shobha.salon &nbsp;· 31K+ followers
                  </a>
                </div>
              </div>
            </div>

            {/* Ratings */}
            <div className={styles.ratingRow}>
              <div className={styles.ratingBadge}>
                ★ 4.8 Google
              </div>
              <div className={styles.ratingBadge}>
                ★ 4.8 Justdial
              </div>
            </div>

            {/* Action buttons */}
            <div className={styles.actionBtns}>
              <a
                href="tel:+918890469900"
                className={styles.actionBtn}
              >
                <span className={styles.icon}>📞</span>
                Call Now
              </a>
              <a
                href="https://wa.me/918890469900"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.actionBtn}
              >
                <span className={styles.icon}>💬</span>
                Chat on WhatsApp
              </a>
              <a
                href="https://www.instagram.com/shobha.salon/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.actionBtn}
              >
                <span className={styles.icon}>📸</span>
                View on Instagram
              </a>
            </div>
          </motion.div>

          {/* Right — Form */}
          <motion.div className={styles.formCard} {...fadeUp(0.2)}>
            <h3 className={styles.formTitle}>Quick Inquiry</h3>
            <p className={styles.formSub}>
              Fill in your details below and we will open WhatsApp with your message ready to send.
            </p>

            <form className={styles.form} onSubmit={handleSubmit} noValidate>
              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="name">Your Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className={styles.formInput}
                  placeholder="e.g. Priya Sharma"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="phone">Phone Number</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  className={styles.formInput}
                  placeholder="+91 98765 43210"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="service">Service Interested In</label>
                <select
                  id="service"
                  name="service"
                  className={styles.formSelect}
                  value={form.service}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>Select a service</option>
                  {SERVICES.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel} htmlFor="date">Preferred Date</label>
                <input
                  id="date"
                  name="date"
                  type="date"
                  className={styles.formInput}
                  value={form.date}
                  onChange={handleChange}
                  required
                  style={{ colorScheme: 'dark' }}
                />
              </div>

              <button type="submit" className={styles.submitBtn}>
                Send via WhatsApp →
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
